import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ZoomOAuth} from "../classes/ZoomOAuth";
import {ZoomPermissions} from "../classes/ZoomPermissions";

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'}),
};

@Injectable({
  providedIn: 'root',
})
export class ZoomOAuthService {

  constructor(private httpClient: HttpClient) {
  }

  public getOAuthLink(roomId): Observable<ZoomOAuth> {
    return this.httpClient.get<ZoomOAuth>(`${environment.backendApiUrl}/v1/zoom?roomId=${roomId}`, httpOptions);
  }

  public isPermissionGranted(roomId): Observable<ZoomPermissions> {
    return this.httpClient.get<ZoomPermissions>(`${environment.backendApiUrl}/v1/zoom/is-permission-granted?roomId=${roomId}`, httpOptions);
  }

}
